import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { InputAdornment, makeStyles } from '@material-ui/core';
import NumberInput from '~/modules/common/components/NumberInput';

const percentAdornment = <InputAdornment position="end">%</InputAdornment>;

const MIN_PERCENT_MARKUP = -100;
const MAX_PERCENT_MARKUP = 999.99;

const isPercentMarkupAllowed = ({ floatValue }) =>
  floatValue === undefined ||
  (floatValue >= MIN_PERCENT_MARKUP && floatValue <= MAX_PERCENT_MARKUP);

const percentMarkupNumberFormatProps = { isAllowed: isPercentMarkupAllowed };

const useStyles = makeStyles(theme => ({
  percentField: {
    '& .MuiFilledInput-root': {
      alignItems: 'center'
    },
    '& input': {
      paddingTop: theme.spacing(1.75),
      paddingBottom: theme.spacing(1.75)
    },
    '& .MuiInputAdornment-positionEnd': {
      marginTop: 0,
      alignSelf: 'center'
    }
  }
}));

export const CostOverridePercentEditor = ({
  value,
  onChange,
  disabled = false,
  dataQeId
}) => {
  const classes = useStyles();
  const { formatMessage } = useIntl();

  const handleValueChange = useCallback(
    e => {
      onChange(e?.target?.value ?? 0);
    },
    [onChange]
  );

  return (
    <NumberInput
      className={classes.percentField}
      value={value}
      onValueChange={handleValueChange}
      precision={2}
      allowNegative
      reactNumberFormatProps={percentMarkupNumberFormatProps}
      editable={!disabled}
      endAdornment={percentAdornment}
      ariaLabel={formatMessage({
        id: 'projectCostOverrides.type.percentMarkup'
      })}
      dataQeId={dataQeId}
    />
  );
};

CostOverridePercentEditor.propTypes = {
  value: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  dataQeId: PropTypes.string
};

export default CostOverridePercentEditor;
